import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { DeploymentState } from './deployment.reducer';

export const $deploymentState = (state: AppState): DeploymentState =>
    state.deployment;

export const $siteDeployments = createSelector(
    $deploymentState,
    state => state.deploymentBundles,
);

export const $siteReleases = createSelector(
    $deploymentState,
    state => state.releases,
);

export const $siteReleasesLoading = createSelector(
    $deploymentState,
    state => state.releasesLoading,
);

export const $version = createSelector(
    $deploymentState,
    state => state.version,
);

export const $downloadingDeployment = createSelector(
    $deploymentState,
    state => state.downloadingDeployment,
);

export const $creatingTemplates = createSelector(
    $deploymentState,
    state => state.creatingTemplates,
);

export const $siteCredentials = createSelector(
    $deploymentState,
    state => state.credentials,
);
